import $ from "jquery";

function init() {
  // Toggle class
  $(".js-toggle-class").click(function() {
    const toggleClass = $(this).data("class");
    if ($(this).attr("data-target")) {
      const target = $(this).data("target");
      $(target).toggleClass(toggleClass);
      $(this).toggleClass("toggled");
    } else {
      $(this).toggleClass(toggleClass);
    }
    return false;
  });

  // Prevent disabled links/buttons
  // @ts-expect-error ignore no return value
  $(".btn, a, button, input[type=submit]").click(function(e) {
    if ($(this).hasClass("btn-disabled") || $(this).hasClass("disabled")) {
      e.preventDefault();
      return false;
    }
  });
}

export default { init };
